module.exports = __webpack_public_path__ + "img/guide01.5ea27b3e.png";